import Lottie from "lottie-react";
import styles from "./JackpotCardsLoader.module.scss";
import CasinoLoader from "@/assets/lottie/Casino_Loader.json";

const JackpotCardsLoader = () => (
  <div className={styles.loader}>
    <div className={styles.lottie}>
      <Lottie animationData={CasinoLoader} />
    </div>
  </div>
);

export default JackpotCardsLoader;
